import Main from "../MainJoinRequests/JoinRequests/Main.js";
import Footer from "../Footer/Footer.js";

const Website = () => {
  return (
    <div>
      <Main />
      <Footer />
    </div>
  );
};

export default Website;
